const formateDate = (date: string) => {
  const _date = new Date(date);
  return new Intl.DateTimeFormat('en-US', { month: 'long' }).format(_date);
};

const getEventImageDate = (date: string) => {
  const _date = new Date(date);
  const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(
    _date
  );
  const year = new Intl.DateTimeFormat('en-US', { year: 'numeric' }).format(
    _date
  );
  const day = new Intl.DateTimeFormat('en-US', { day: '2-digit' }).format(
    _date
  );
  return { month, year, day };
};

export { formateDate, getEventImageDate };
